// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'efe5aea2-845d-44d3-a03e-b327f1d1fb4c',
      type: 'Sprite',
      name: 'chestClosed',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Chest_Gold',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        '3rd': {
          texture: 'Race_Event_Chest_Bronze'
        },
        '2nd': {
          texture: 'Race_Event_Chest_Silver'
        }
      },
      interactiveChildren: false
    },
    {
      id: 'bf1191b6-616e-486f-a874-4e0a550d1be2',
      type: 'Sprite',
      name: 'chestOpened',
      className: '',
      x: 0,
      y: -140,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 10,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Chest_Gold_Open',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      interactiveChildren: false
    },
    {
      id: 'b1fee1c5-f27f-4194-93db-49a77e0ba3ac',
      type: 'Container',
      name: 'giftSpawnPoint',
      className: '',
      x: 0,
      y: -140,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '1.0.0',
  animations: [
    {
      id: 'f613ae95-0203-4915-8465-3c60e62b5914',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: []
    },
    {
      id: 'd037e6e9-888e-4d98-895f-c350543d9142',
      name: 'Open',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '5d03535f-0dce-4823-b1a3-11053e5407df',
          type: 'Tween',
          name: 'squeeze1',
          duration: 100,
          track: 3,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 74,
          sourceName: 'chestClosed',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0561258b-44e3-4648-bc82-9bba4e7b1a30',
          type: 'Tween',
          name: 'rotation1',
          duration: 300,
          track: 2,
          target: {
            angle: 10
          },
          startAt: 150,
          sourceName: 'chestClosed',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '9fa4a3a6-6e3a-4abe-ba11-9c17d4c5994c',
          type: 'Tween',
          name: 'translation1',
          duration: 300,
          track: 1,
          target: {
            y: -140
          },
          startAt: 150,
          sourceName: 'chestClosed',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '892f218c-6b89-453d-a2f0-8f7d56810b40',
          type: 'Tween',
          name: 'squeeze2',
          duration: 100,
          track: 3,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 235,
          sourceName: 'chestClosed',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '72017ede-53e0-49a8-a4d6-a212920503d4',
          type: 'Setter',
          name: 'ANIMEVENT_spawnGifts',
          track: 4,
          target: {},
          startAt: 450,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '254d66de-5223-4766-8d0f-1f280fd3ae2a',
          type: 'Setter',
          name: 'chestClosedInvisible',
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 450,
          sourceName: 'chestClosed',
          disabled: false
        },
        {
          id: '2dfcfa8e-8006-414b-985a-1b3b2e8f84b5',
          type: 'Setter',
          name: 'chestOpenVisible',
          track: 5,
          target: {
            alpha: 1
          },
          startAt: 450,
          sourceName: 'chestOpened',
          disabled: false
        },
        {
          id: 'e4bb1b0a-09b3-4f50-bf22-e8d56433de38',
          type: 'Tween',
          name: 'rotation2',
          duration: 150,
          track: 2,
          target: {
            angle: 0
          },
          startAt: 470,
          sourceName: 'chestOpened',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a6ff42c8-08b7-4233-b390-1acb279de60c',
          type: 'Tween',
          name: 'translation2',
          duration: 170,
          track: 1,
          target: {
            y: 0
          },
          startAt: 500,
          sourceName: 'chestOpened',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '41e2faab-8b7a-433f-bf46-c3d98288c5c6',
          type: 'Tween',
          name: 'squeeze3',
          duration: 100,
          track: 3,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 578,
          sourceName: 'chestOpened',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '10be5fee-a51d-41b9-a6b2-582f98b779a7',
          type: 'Tween',
          name: 'squeeze4',
          duration: 100,
          track: 3,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 700,
          sourceName: 'chestOpened',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class BasicRewardChestLayout {
  static raw = raw;
  root!: Container;
  chestClosed!: Sprite;
  chestOpened!: Sprite;
  giftSpawnPoint!: Container;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Idle {
  Layout: {

  };

  BlockTypeByName: {};

  flowData = raw.animations[0];
}

export abstract class Open {
  Layout: {
    chestClosed: object;
    root: object;
    chestOpened: object;
  };

  BlockTypeByName: {
    squeeze1: object;
    rotation1: object;
    translation1: object;
    squeeze2: object;
    ANIMEVENT_spawnGifts: object;
    chestClosedInvisible: object;
    chestOpenVisible: object;
    rotation2: object;
    translation2: object;
    squeeze3: object;
    squeeze4: object;
  };

  flowData = raw.animations[1];
}
